// extracted by mini-css-extract-plugin
module.exports = {"tab":"CreditCardDialog__tab--1XwBC","tabWrapper":"CreditCardDialog__tabWrapper--3boOb"};